export default "__VITE_ASSET__D_ABBSTM__"